import { Outlet } from "react-router-dom";

const Clientes = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Clientes;
